import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  tableRow: {
    borderBottom: `1px solid ${colors.neutral[300]}`,
    '&:last-of-type': {
      borderBottom: 'none',
    },
  },
  tableCell: {
    font: { size: '1.6rem', lineHeight: '2.4rem' },
    color: colors.neutral[900],
    letterSpacing: '0.02rem',
    padding: '1.6rem 0.5rem',
    '&:first-child': {
      paddingLeft: '2.4rem',
      width: '4rem',
    },
    '&:nth-child(2)': {
      paddingRight: '2rem',
      width: '4rem',
    },
    '&:last-child': {
      paddingRight: '2.4rem',
      width: '5rem',
    },
  },
  emailStatusCell: {
    width: '5rem',
  },
  actionButton: {
    textTransform: 'uppercase',
    padding: 0,
    '&:last-child': {
      marginLeft: 'auto',
    },
  },
  emailStatus: {
    display: 'grid',
    gridTemplateColumns: 'minmax(5rem, max-content) 2.3rem',
    alignItems: 'center',
    gap: '1rem',
    fontSize: '1.6rem',
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
